class SwiperSlider extends HTMLElement {
    constructor(){
        super();
        this.options = this.getAttribute('data-swiper') ? JSON.parse(this.getAttribute('data-swiper')) : {};
        this.selector = this.dataset.selector;
    }

    connectedCallback() {
        if (this.querySelector(`.swiper.${this.selector}`)) {
            this.initSlider();
        } 
    }

    initSlider() {
        let swiper;
        if(Swiper !== 'undefined'){
            let swiperElement = this.querySelector(`.swiper.${this.selector}`);
            swiper = new Swiper(swiperElement, this.options);
        }        
    }
}

customElements.define('swiper-slider', SwiperSlider);


class SwiperUtils {
    /**
     * @param {Object} swiper - The swiper instance to be updated.
     */
    static update(swiper){
        swiper.update();
    }
}